import styled from 'styled-components';
import { convertColorToThemeHexCode } from 'Styles/colors.util';

export const PaginationDots = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1px solid var(--ring);
  margin-right: 8px;
  background-color: ${(props) =>
    props.selected && convertColorToThemeHexCode('grey80')};

  &:last-child {
    margin-right: 0;
  }
`;
